import * as React from "react";

function SvgOracleEloqua(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 49.399 19.434"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        fill="#6A757C"
        d="M17.338 4.507a4.744 4.744 0 014.744 4.658 2.797 2.797 0 005.588 0h1.952a4.746 4.746 0 01-9.491 0 2.797 2.797 0 00-2.793-2.706 2.799 2.799 0 00-2.796 2.706H12.59a4.75 4.75 0 014.748-4.658"
      />
      <path
        fill="#EC1C24"
        d="M37.598 4.497v4.667c0 .018 0 .033-.002.048a2.793 2.793 0 01-5.582.009l-.002-4.739h-1.953l.001 4.73a4.746 4.746 0 004.745 4.612 4.75 4.75 0 004.747-4.602V4.497h-1.954zM9.96 0l.002 13.802h1.953V0H9.96zM44.602 11.96a2.798 2.798 0 01-2.798-2.795c.048-1.501 1.335-2.706 2.85-2.706 1.072 0 2.001.604 2.473 1.488a2.8 2.8 0 01-2.525 4.013m4.797 1.862V12.065v.037-2.957a4.747 4.747 0 00-6.1-4.442 4.628 4.628 0 00-3.387 4.329l-.006.133h.004a4.628 4.628 0 004.625 4.626 4.6 4.6 0 002.911-1.034v1.066h1.953zM17.338 13.824a4.744 4.744 0 004.744-4.66 2.797 2.797 0 015.587-.03l.001 10.3h1.952V9.144a4.748 4.748 0 00-9.491.02 2.797 2.797 0 01-2.793 2.71 2.799 2.799 0 01-2.796-2.71H12.59a4.75 4.75 0 004.748 4.66M6.953 8.075a2.2 2.2 0 00-.856-1.185c-.424-.304-.917-.454-1.479-.454-.609 0-1.146.17-1.604.51-.29.214-.557.592-.802 1.129h4.741zm2.188 1.723H2.115c.102.62.371 1.111.812 1.479.441.365 1.005.548 1.688.548.817 0 1.519-.285 2.105-.858l1.844.867c-.46.65-1.013 1.133-1.652 1.444-.64.313-1.4.469-2.282.469-1.368 0-2.48-.43-3.342-1.294C.429 11.591 0 10.512 0 9.215c0-1.33.428-2.436 1.285-3.312.857-.882 1.933-1.319 3.225-1.319 1.373 0 2.488.438 3.349 1.318.858.877 1.29 2.039 1.29 3.479l-.008.417z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgOracleEloqua);
